const hy = {
  downloadButtonLabel: 'Download PDF',
};

export default hy;
